module.exports = __webpack_public_path__ + "img/03.213fbec6.png";